const axios = require('axios')
const consentUrl = process.env.REACT_APP_HOST_API + '/consent'

export const checkConsent = async (userId, sessionId) => {
  try {
    const res = await axios.get(`${consentUrl}/check/${userId}/${sessionId}`)
    return res.data
  } catch (error) {
    console.error('Error checking consent:', error)
    throw error
  }
}

export const submitConsent = async (userId, sessionId, hasConsented) => {
  try {
    const res = await axios.post(`${consentUrl}/submit`, {
      userId,
      sessionId,
      hasConsented
    })
    return res.data
  } catch (error) {
    console.error('Error submitting consent:', error)
    throw error
  }
}